var _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuFairIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 88,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11c0-3 2-5 5-5h86a4 4 0 1 1 0 9H5c-3 0-5-2-5-4Z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 10,
    r: 10,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43 17h10v57H43z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77 88H20c2-9 14-15 29-15 14 0 26 6 28 15ZM16 61c8 0 15-6 15-14 0-9-13-28-15-28S1 38 1 47c0 8 7 14 15 14Zm9-19-8-13h-2L7 42l1 2h16l1-2ZM81 61c8 0 15-6 15-14 0-9-13-28-15-28S66 38 66 47c0 8 7 14 15 14Zm9-19-8-13h-2l-8 13 1 2h16l1-2Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuFairIcon);
export default __webpack_public_path__ + "static/media/menu-fair-icon.1d03d7c268e99f292c9aedf58ed8093d.svg";
export { ForwardRef as ReactComponent };